<template>
	<page class="dashboard" title="Brugere" style="background-color: #F0F0F0;">
		<button-view style="float: left;" slot="tools" @click="createUser">+ Bruger</button-view>
		<new-table-view class="list" @itemClick="itemClick" :columns="[
			{
				label: 'Brugernavn',
				name: 'username'
			},
			{
				label: '',
				name: 'delete',
				align: 'right',
				template: {
					name: 'button',
					label: 'Slet'
				},
				weight: '100px'
			}
		]" :items="_items" @context="itemContext" @delete="itemDelete" />
	</page>
</template>

<script>
	import { bus } from '../../bus'

	import user from '../model/user';

    export default {
		data() {
			return {
				items: []
			};
		},
		components: {

		},
		watch: {

		},
		computed: {
			_items() {
				return this.items;
			}
		},
		methods: {
			async itemDelete(item, event) {
				event.stopPropagation();
				console.log('item delete', item);

				if (confirm('Sikker?')) {
					await this.axios.delete(`/users/${item.id}`);
					this.update();
				}
			},
			itemContext(item, event) {
				/*event.stopPropagation();

				var self = this;

				var actions = [];

				if (item.type == 'survey') {
					actions.push({
						label: 'Print privat',
						action: async function () {
							window.open(process.env.VUE_APP_API + '/planning/tasks/' + item.id + '/private/print/?token=' + self.$store.state.auth);
						}
					});

					actions.push({	
						label: 'Print erhverv',
						action: async function () {
							window.open(process.env.VUE_APP_API + '/planning/tasks/' + item.id + '/business/print/?token=' + self.$store.state.auth);
						}
					});

					actions.push(null);
				}

				actions.push({
					label: 'Slet',
					action: async function () {
						if (await TaskModel.delete(self.axios, item.id)) {
							self.update();
						}
					}
				});

				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.currentTarget,
					align: 'left',
					actions: actions
				});*/
			},
			async itemClick(item) {
				console.log('item click', item);
				const self = this;

				user.open(item.id, () => {
					self.update();
				});
			},
			async update() {
				this.items = (await this.axios.get('/users')).data;
			},
			createUser() {
				console.log('Create user');

				const self = this;

				user.open(null, () => {
					self.update();
				});
			}
		},
		mounted() {
			this.update();

			var self = this;

			bus.$on('update', function () {
				self.update();
			});

			bus.$on('clear', function () {
				self.items = null;
			});
		},
		beforeRouteLeave(to, from, next) {
			bus.$off('update');
			bus.$off('clear');

			next();
		}
    }
</script>

<style lang="scss" scoped>
	.layout {
		width: 100%;
		height: 100%;
		display: grid;
		grid-template-columns: 320px 1fr;
		grid-template-rows: 290px 1fr;

		& > .new-table-view {
			width: 100%;
			height: 100%;
		}
	}

	.date {
		grid-column: 1;
		grid-row: 1;
		background-color: #f0f0f0;
		padding: 30px;
	}

	.tasks {
		grid-column: 1;
		grid-row: 2 / 3;
		background-color: #f0f0f0;		
	}

	.list {
		width: 100%;
		height: 100%;
		border-left: 1px solid #cecece;
		background-color: white;
	}
</style>